import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { userRole_proctorLead } from '../../../Common/appConstant';
import { AppGlobals } from '../../../Common/Services/app.global';
import { Enum } from '../../../utility/enum.enum';
import { AppMessage } from './../../../Common/appMessage';
import { SharedService } from './../../../Common/Services/shared.service';
import { Utility } from './../../../Common/Services/utility';
import { AdmManageProctorTeamLeadService } from './../adm-manage-proctor-team-lead.service';
import { AdmUpdateProctorTeamLeadService } from './adm-update-proctor-team-lead.service';
import { AppConfig } from 'app/Common/appConfiguration';

@Component({
  selector: 'app-adm-update-proctor-team-lead',
  templateUrl: './adm-update-proctor-team-lead.component.html',
  styleUrls: ['./adm-update-proctor-team-lead.component.css'],
  providers: [AdmUpdateProctorTeamLeadService]
})
export class AdmUpdateProctorTeamLeadComponent implements OnInit {

  form: FormGroup;
  id: number = 0;
  role: any;
  redirectUrl: any;
  showField: boolean = true;
  pageConfig: {
    title: string,
    isSaveDisable: boolean,
    isEditDisable: boolean,
    isRetireDisable: boolean,
    isActiveDisable: boolean
  };
  officeFilteredOptions: any;
  groupOptions: any;
  proctorLeadOptions: any;
  constructor(private _sharedService: SharedService, public _utility: Utility, private _activatedRoute: ActivatedRoute
    , private _appMessage: AppMessage, private _updateService: AdmUpdateProctorTeamLeadService, private _appGlobal: AppGlobals,
    private _manageService: AdmManageProctorTeamLeadService
  ) {

    this.form = new FormGroup(
      {
        firstName: new FormControl(''),
        lastName: new FormControl(''),
        userEmail: new FormControl('', [Validators.pattern(AppConfig.emailPattern)]),
        contactNumber: new FormControl('', [Validators.pattern(AppConfig.phoneNumberRegEx)]),
        rhId: new FormControl('', Validators.required),
        maxSession: new FormControl('', [Validators.required, Validators.pattern(AppConfig.onlyNumericRegEx)]),
        officeId: new FormControl('', Validators.required),
        groupId: new FormControl('', Validators.required),
        islead: new FormControl('', Validators.required),
      })
    this.checkPermission();
    this.pageConfig = {
      title: 'Add Proctor',
      isSaveDisable: false,
      isEditDisable: true,
      isRetireDisable: true,
      isActiveDisable: true
    };
    this.form.valueChanges
      .debounceTime(400)
      .subscribe(form => {
        if (!this.form.disabled && this.form.dirty) {
          this._utility.setTxnStatus(true); // display confirm box for FORM changes
        }
      });
  }

  ngOnInit() {
    this._appGlobal.routeWithID = false;
    this._utility.setDataInComboField('office', null, this.form.controls.officeId, this);
    //this.officeOptions = this._manageService.officeList;
    this.groupOptions = this._manageService.groupList;
    this.proctorLeadOptions = this._manageService.proctorLeadList;
    this.id = this._activatedRoute.snapshot.params["id"];
    if (this.id > 0) {
      this.pageConfig.title = 'Edit Proctor';
      this.pageConfig.isEditDisable = false;
      this.pageConfig.isSaveDisable = true;
      this.getProctorDetail();
    }
  }

  checkPermission() {
    this.role = this._appGlobal.userInfo.getValue().userRole;
    if (this.role && this.role == userRole_proctorLead) {
      this.showField = false;
      this.form.controls.islead.setValue({ value: 1 });
      this.redirectUrl = 'AdmManageProctors';
    } else {
      this.showField = true;
      this.redirectUrl = 'AdmManageProctorTeamLead';
    }
  }

  getProctorDetail() {
    this._utility.addLoaderCount();
    this._updateService.getDataById(this.id).subscribe((response: any) => {
      this._utility.onSuccessCallback(response, null, () => {
        if (response && response.response) {
          let data = response.response.results[0];
          // disable edit feature if user is retired
          if (data.isDeleted) {
            this.pageConfig.isActiveDisable = false;
            this.pageConfig.isRetireDisable = true;
            this.pageConfig.isEditDisable = true;
          }
          else {
            this.pageConfig.isActiveDisable = true;
            this.pageConfig.isRetireDisable = false;
            this.pageConfig.isEditDisable = false;
          }
          const islead = this.proctorLeadOptions.find(elm => elm.value == data.islead);
          data.groupId = this.getselectedGroupData(data);
          data.islead = islead;
          let finalData = this._utility.manageFormComboData(data);
          if (finalData) {
            this.form.patchValue(finalData);
          }
          this._utility.disableEnableForm(this.form, true);
        }
      });
    },
      error => this._utility.onErrorCallback(error));
  }

  getselectedGroupData(data) {
    let selectedGroup = []
    for (let i = 0; i < data.groupId.length; i++) {
      this.groupOptions.filter(elm => {
        if (elm.id == data.groupId[i]) {
          selectedGroup.push(elm);
        }
      })
    }
    return selectedGroup;
  }

  onSave(): void {
    if (this.id) {
      let formValues = this.form.getRawValue();
      formValues = this._utility.manageFormDataforSave(formValues);
      formValues.id = this.id;
      formValues.islead = formValues.islead.value;
      this._utility.addLoaderCount();
      this._updateService.saveData(formValues).subscribe((response: any) => {
        let msg = this.id == 0 ? this._appMessage.getItem['UMsg00030'] : this._appMessage.getItem['UMsg00031'];
        this._utility.onSuccessCallback(response, msg, () => {
          this.pageConfig.isSaveDisable = true;
          this.pageConfig.isEditDisable = false;
          if (this.id == 0) {
            this.pageConfig.isRetireDisable = false; // disable retire button after save new record
          }
          this.id = response.response.id; // set new user Id
          this._utility.disableEnableForm(this.form, true);
          this._utility.clearTxnStatus(); // close confirm box for FORM changes
        })
      }, error => this._utility.onErrorCallback(error))
    }

  }

  /**
   * When perform edit button action
   * make Edit button disable, save button enable, enable Form
   * Mark all fields as touched so that in case field does not have any value, it shows required field validations.
   */
  onEdit(): void {
    this.pageConfig.isEditDisable = true;
    this.pageConfig.isSaveDisable = false;
    this._utility.disableEnableForm(this.form, false);
    this.form.controls.officeId.markAsTouched();
  }

  /**
   * 0 - Active & 1 - Retire
   * @param status - It will be 0 or 1
   */
  onUpdateStatus(status: number) {
    let params = {
      id: this.id,
      proctorStatus: status
    }
    this._utility.addLoaderCount();
    this._updateService.updateStatus(params).subscribe(response => {
      let msg;
      if (this.role && this.role == userRole_proctorLead) {
        if (status == Enum.proctorTeamLead_Active) {
          msg = this._appMessage.getItem['UMsg00073'];
        } else {
          msg = this._appMessage.getItem['UMsg00072'];
        }
      } else {
        if (status == Enum.proctorTeamLead_Active) {
          msg = this._appMessage.getItem['UMsg00068'];
        } else {
          msg = this._appMessage.getItem['UMsg00067'];
        }
      }

      this._utility.onSuccessCallback(response, msg, () => {
        this._utility.disableEnableForm(this.form, true);
        if (status == Enum.proctorTeamLead_Active) {
          this.pageConfig.isRetireDisable = false;
          this.pageConfig.isActiveDisable = true;
          this.pageConfig.isEditDisable = false;
          this.pageConfig.isSaveDisable = true;
        } else {
          this.pageConfig.isRetireDisable = true;
          this.pageConfig.isActiveDisable = false;
          this.pageConfig.isEditDisable = true;
          this.pageConfig.isSaveDisable = true;
        }
      })
    }, error => this._utility.onErrorCallback(error))
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-team-lead/adm-update-proctor-team-lead/adm-update-proctor-team-lead.component.ts